import { Component, Injector,OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-testreset',
  templateUrl: './testreset.component.html',
  styleUrls: ['./testreset.component.css']
})
export class TestresetComponent extends BaseComponent{
  constructor(injector: Injector) { super(injector) }
  users: any = []
  userid = 0
  url = ""
  token = ""

  async ngOnInit() {
    this.loader.show()
    this.users = await this.db.get("Authenticate","getallusers");
    this.users = this.sort(this.users,"userName")
    this.loader.hide()
  }


  sendEmail(){
    // isTest == true means the email link goes to peter.schmitt.cellpodium.com and uses localhost
    let user = this.users.find((x:any) => x.id == this.userid)
    this.db.get("Authenticate","SetResetTokenAndSendEmail",{ email: user.email,isTest: false})
    this.toast.success("Email sent")
  }
  
}
